export const DIRECTIONS = {
    horizontal: 'horizontal',
    vertical: 'vertical',
};
export const SKINS = {
    light: 'light',
    dark: 'dark',
    standard: 'standard',
    warning: 'warning',
    destructive: 'destructive',
    success: 'success',
    premium: 'premium',
};
//# sourceMappingURL=Divider.constants.js.map